/**
 * 积分规则接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PointsRuleService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region 
  /**
   * 积分规则类型查询
   */
  queryPageListRuleType(param) {
    const url = this.prefix + 'pointsRuleType/queryPageList';
    return this.http.Post(url, param);
  }
  /**
   * 积分规则类型新增
   */
  saveRuleType(param) {
    const url = this.prefix + 'pointsRuleType/save';
    return this.http.Post(url, param);
  }
  /**
   * 积分规则类型修改
   */
  updateByIdRuleType(param) {
    const url = this.prefix + 'pointsRuleType/updateById';
    return this.http.Post(url, param);
  }
/**
   * 积分规则类型查询根据ID
   */
  queryByIdRuleType(param) {
    const url = this.prefix + 'pointsRuleType/queryById';
    return this.http.Post(url, param);
  }
/**
   * 积分规则类型删除
   */
  deleteBatchRuleType(param) {
    const url = this.prefix + 'pointsRuleType/deleteBatch';
    return this.http.Post(url, param);
  }


   //#region 
  /**
   * 积分规则查询
   */
  queryPageListRule(param) {
    const url = this.prefix + 'pointsRule/queryPageList';
    return this.http.Post(url, param);
  }
  /**
   * 积分规则新增
   */
  saveRule(param) {
    const url = this.prefix + 'pointsRule/save';
    return this.http.Post(url, param);
  }
  /**
   * 积分规则修改
   */
  updateByIdRule(param) {
    const url = this.prefix + 'pointsRule/updateById';
    return this.http.Post(url, param);
  }
  /**
   * 积分规则状态更新
   */
  updateStatus(param) {
    const url = this.prefix + 'pointsRule/updateStatus';
    return this.http.Post(url, param);
  }
/**
   * 积分规则查询根据ID
   */
  queryByIdRule(param) {
    const url = this.prefix + 'pointsRule/queryById';
    return this.http.Post(url, param);
  }
/**
   * 积分规则删除
   */
  deleteBatchRule(param) {
    const url = this.prefix + 'pointsRule/deleteBatch';
    return this.http.Post(url, param);
  }

  //下拉列表
  querySelectList(param) {
    const url = this.prefix + 'pointsRuleType/querySelectList?'+param;
    return this.http.Get(url);
  }

  //查询预警配置
  queryPointsWarm(param) {
    const url = this.prefix + 'pointsWarm/queryPointsWarm?'+param;
    return this.http.Get(url);
  }
  //保存预警配置
  savePointsWarm(param) {
    const url = this.prefix + 'pointsWarm/savePointsWarm';
    return this.http.Post(url,param);
  }
  
}
